import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { PipelineBoard } from "../components/ops/PipelineBoard";
import { BatchBuilder, PriceList, LookCheck, WeeklyReport } from "../components/ops/OpsTabs";
import { RepairsPanel } from "../components/ops/RepairsPanel";
import { FixAllPanel } from "../components/ops/KitOps";
import { RunningJobs } from "../components/ops/RunningJobs";
import { CheckAllPanel } from "../components/kit/CheckAllPanel";

const trig = "rounded-none border-b-2 border-transparent data-[state=active]:border-[#C9A847] data-[state=active]:shadow-none px-4 py-2";

export default function Production() {
  return (
    <div data-testid="production-page" className="p-8 lg:p-12 max-w-[1600px]">
      <div className="eyebrow mb-2">Production</div>
      <h1 className="font-display text-4xl text-[#2B2A26] mb-6">Pipeline & tools</h1>
      <RunningJobs />
      <CheckAllPanel />
      <RepairsPanel />
      <FixAllPanel />
      <Tabs defaultValue="pipeline">
        <TabsList className="bg-transparent rounded-none h-auto p-0 border-b border-stone-200 w-full justify-start mb-6">
          <TabsTrigger data-testid="tab-pipeline" className={trig} value="pipeline">Pipeline</TabsTrigger>
          <TabsTrigger data-testid="tab-batch" className={trig} value="batch">Batch builder</TabsTrigger>
          <TabsTrigger data-testid="tab-prices" className={trig} value="prices">Price & wording list</TabsTrigger>
          <TabsTrigger data-testid="tab-looks" className={trig} value="looks">Look check</TabsTrigger>
          <TabsTrigger data-testid="tab-weekly" className={trig} value="weekly">Weekly report</TabsTrigger>
        </TabsList>
        <TabsContent value="pipeline"><PipelineBoard /></TabsContent>
        <TabsContent value="batch"><BatchBuilder /></TabsContent>
        <TabsContent value="prices"><PriceList /></TabsContent>
        <TabsContent value="looks"><LookCheck /></TabsContent>
        <TabsContent value="weekly"><WeeklyReport /></TabsContent>
      </Tabs>
    </div>
  );
}
